import { axiosInstanceWithToken } from "@/utils/axios";
import { HOST_API_KEY } from "../../config";

export const createLoginSession = async (data) => {
  const request = await axiosInstanceWithToken.post(
    `${HOST_API_KEY}/login-session/create`,
    data
  );
  return request?.data;
};

export const getAllLoginSessions = async (params) => {
  const request = await axiosInstanceWithToken.get(`${HOST_API_KEY}/admin/login-session/all`, {
    params,
  });
  return request?.data;
};

export const deleteSessionsInBulk = async (data) => {
  const request = await axiosInstanceWithToken.delete(
    `${HOST_API_KEY}/admin/login-session/delete/bulk`,
    {
      params: data,
    }
  );
  return request?.data;
};
